<ng-container *ngIf="isPageAvailable && !loader">
  <div id="staticPageHead-{{url}}"></div>
  <div id="staticPageContent-{{url}}"></div>
</ng-container>

<div *ngIf="!isPageAvailable && !loader" class="pagenot_found">
  <app-pagenotfound></app-pagenotfound>
</div>

<div class="container-fluid" *ngIf="url === 'footerfaq' && isPageAvailable && !loader">
  <app-static-faq-category (categoryNameEmit)="categoryChangeHandler($event)"></app-static-faq-category>
</div>

<div class="main-pages_loader loading-div" *ngIf="loader && url !== 'footer'">
  <div class='loader loader-large'></div>
</div>